import * as React from 'react';
import StripeCheckout from 'react-stripe-checkout';
import RectangleButton from '../components/Buttons/RectangleButton';
import storewith_penn_icon from 'src/assets/penn_storage_icon.svg';

interface props {
  onSubmit: Function;
  amount: number;
  keyId?: number;
  buttonText: string;
  style?: React.CSSProperties;
  invalid: boolean;
  hostName: string;
  id: string;
}

const isProduction = process.env.NODE_ENV === 'production';

let backendUrl = 'http://localhost:4000/charge';

if (isProduction) {
  backendUrl = 'https://api.storewithpenn.com/charge';
}

class Checkout extends React.Component<props> {
  onToken = (token: any) => {
    const body = {
      amount: this.props.amount,
      token_id: token.id,
      hostName: this.props.hostName,
      id: this.props.keyId,
    };
    // update to production URL
    fetch(backendUrl, {
      method: 'POST',
      body: JSON.stringify(body),
    }).then(response => {
      if (response.status === 200) {
        this.props.onSubmit(token, this.props.keyId);
      } else {
        console.log(response);
      }
    });
  };

  render() {
    return (
      <StripeCheckout
        name="StoreWith Penn"
        description="Easy, cheap, reliable storage."
        image={storewith_penn_icon}
        amount={this.props.amount}
        token={this.onToken}
        // publishable prod key
        stripeKey="pk_live_9Zwm6sX5AuQ2p51CG9Qm69RK"
      >
        <RectangleButton invalid={this.props.invalid} style={this.props.style}>
          {this.props.buttonText}
        </RectangleButton>
      </StripeCheckout>
    );
  }
}

export default Checkout;



// WEBPACK FOOTER //
// ./src/components/Checkout.tsx